import moment from "moment";

const getDateFromAPIPagos = (fecha) => {
  var fecha = moment(fecha);
  return fecha.format("DD/MM/YYYY"); // Resultado: "28/12/2022"
};

export default getDateFromAPIPagos;
